import {
  FaBolt,
  FaExpandArrowsAlt,
  FaDatabase,
  FaStream,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-kafka.png";

export const KAFKA_CONSTANTS = {
  HERO: {
    title: "OneMind Services — Apache Kafka (One-Click Application) ",
    desc: "Streamline your data processing with OneMind’s fully managed Apache Kafka. We handle the infrastructure, so you can focus on building real-time applications effortlessly.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Apache Kafka is an open-source distributed event streaming platform used by thousands of companies for high-performance data pipelines, streaming analytics, data integration, and mission-critical applications.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure Apache Kafka instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach :   Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Kafka broker, Zookeeper, default configurations, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "kafka",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    installation: {
      heading: "Installation Location -",
      text: "The configuration files are in the directory ",
      location: "/etc/kafka/  ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["9092 (Kafka broker)", "2181 (Zookeeper)"],
    },
    note: "Note : Find the configuration files at /etc/kafka/ for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaBolt,
        title: "High Throughput",
        text: "Handles large volumes of data with low latency, suitable for real-time analytics.",
      },
      {
        icon: FaExpandArrowsAlt,
        title: "Scalability",
        text: "Easily scale horizontally by adding more brokers to the cluster.",
      },
      {
        icon: FaDatabase,
        title: "Durability",
        text: "Ensures data persistence and fault tolerance through distributed commit logs.",
      },
      {
        icon: FaStream,
        title: "Stream Processing",
        text: "Supports real-time stream processing with Kafka Streams and integration with external systems via Kafka Connect.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for Kafka data and configurations. ",
      },
      {
        label: "Security Out of the Box",
        text: " Hardened with firewall rules, TLS ready, and access control configurations.",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with stream processing frameworks for enhanced performance. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Apache Kafka Documentation",
    docsLink: "https://kafka.apache.org/documentation/",
  },
};
